module.exports = __webpack_public_path__ + "img/clientes-logo-4.0829144d.png";